module.exports = __webpack_public_path__ + "9d196a6f322cec8815bccab9f84f0810.pdf";